import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import { ShoppingCartContext } from 'javascripts/contexts/shopping_cart_context';

import { ChirpButton } from 'javascripts/components/chirp_button';

import heartIconWhite from 'images/Heart_White_2x.png';
import heartIconNavy from 'images/Heart_Navy_2x.png';
import cartIconWhite from 'images/Cart_White_2x.png';
import cartIconNavy from 'images/Cart_Navy_2x.png';

import styles from 'stylesheets/components/cover_shopping_buttons';

const buttonTypes = {
  CART: 'CART',
  WISHLIST: 'WISHLIST',
};

export function CoverShoppingButtons(props) {
  const [inCart, setInCart] = useState(props.inCart);
  const [inWishlist, setInWishlist] = useState(props.inWishlist);

  const { addItemToCart, removeItemFromCart, addItemToWishlist, removeItemFromWishlist } =
    useContext(ShoppingCartContext);

  function getButtonAction(type) {
    if (type === buttonTypes.CART) {
      return inCart ? removeItemFromCart : addItemToCart;
    }
    if (type === buttonTypes.WISHLIST) {
      return inWishlist ? removeItemFromWishlist : addItemToWishlist;
    }
    return Promise.resolve({});
  }

  function getEventActionString(type) {
    if (type === buttonTypes.CART) {
      return inCart ? 'Shopping cart removal mouseover' : 'Shopping cart mouseover';
    }
    if (type === buttonTypes.WISHLIST) {
      return inWishlist ? 'Wishlist removal mouseover' : 'Wishlist mouseover';
    }
    return '';
  }

  function onShoppingButtonClick(type, event) {
    // [CG 10/7/2020] Shift focus back to cover image, so that modal will return
    // focus to cover image, not to hidden cover button to avoid unwanted scroll
    if (!_.isEmpty(props.returnFocusRef)) {
      props.returnFocusRef.current.focus();
    }
    event.stopPropagation(); // Don't track cover click

    const eventAction = getEventActionString(type);

    bubEvents.track(props.trackingCategory, eventAction, {
      label: 'Audiobook id',
      value: props.book.id,
    });

    getButtonAction(type)(props.book, { inWishlist, inCart }).then(data => {
      setInCart(data.inCart);
      setInWishlist(data.inWishlist);
    });
  }

  function renderShoppingCartButton() {
    if (_.isNil(props.book.currentProduct)) {
      return null;
    }

    const addToCartText = inCart ? 'Added to Cart' : 'Add to Cart';

    return (
      <ChirpButton
        attrs={{ 'data-shopping-cart': inCart ? 'remove' : null, tabIndex: '0' }}
        displayStyle={inCart ? 'navy' : 'white'}
        hoverDropShadow
        icon={inCart ? cartIconWhite : cartIconNavy}
        iconSize='large'
        onClick={event => onShoppingButtonClick(buttonTypes.CART, event)}
        round
        iconAltText={addToCartText}
      />
    );
  }

  const addToWishlistText = inWishlist ? 'Added to Wishlist' : 'Add to Wishlist';
  return (
    <div className={classNames(styles.shoppingButtons, { [styles.active]: props.active })}>
      {renderShoppingCartButton()}
      <ChirpButton
        attrs={{ 'data-shopping-cart': inCart ? 'remove' : null, tabIndex: '0' }}
        displayStyle={inWishlist ? 'navy' : 'white'}
        hoverDropShadow
        icon={inWishlist ? heartIconWhite : heartIconNavy}
        iconSize='large'
        onClick={event => onShoppingButtonClick(buttonTypes.WISHLIST, event)}
        round
        iconAltText={addToWishlistText}
      />
    </div>
  );
}

CoverShoppingButtons.propTypes = {
  active: PropTypes.bool.isRequired,
  book: ChirpPropShapes.audiobook.isRequired,
  returnFocusRef: PropTypes.object,
  trackingCategory: PropTypes.string.isRequired,
  inCart: PropTypes.bool,
  inWishlist: PropTypes.bool,
};

CoverShoppingButtons.defaultProps = {
  inCart: false,
  inWishlist: false,
};
